import React, { useState } from "react";
import {
  ActivePathContext,
  BackToContext,
  DrawerContext,
  MenuContext,
  SectionContext,
  SideMenuContext,
  SideMenuWideContext,
  SearchTermContext
} from "../../context";
import { findContext, findInitSideMenu } from "../utilities";

const ContextWrapper = ({ children }) => {
  const { props } = children;
  const { data } = props;
  let markdownRemark, site, frontmatter, slug, menu;
  ({ markdownRemark, site } = data || null);
  if (markdownRemark) {
    ({ frontmatter } = markdownRemark || null);
    ({ slug, menu } = frontmatter || null);
  }
  const context = findContext(slug);
  let siteMetadata;
  if (site) {
    ({ siteMetadata } = site || null);
  }
  let menuLinks;
if (siteMetadata) {
  ({ menuLinks } = siteMetadata || null);

}

  const initSection = context ? context : "Home";
  const initSideMenu = findInitSideMenu(menu, menuLinks, {
    name: "root",
    subMenu: menuLinks,
  });
  const initSideMenuWide = findInitSideMenu(initSection, menuLinks, {
    name: "root",
    subMenu: menuLinks,
  });
  const initBackTo =
    initSideMenu && initSideMenu[0].backTo && initSideMenu[0].backTo !== "none"
      ? initSideMenu[0].backTo
      : null;
  const [activePath, setActivePath] = useState(slug || "/");
  const [backTo, setBackTo] = useState(initBackTo);
  const [drawerActive, setDrawerActive] = useState(false);
  const [menuObject, setMenuObject] = useState(menuLinks);
  const [section, setSection] = useState(initSection);
  const [sideMenu, setSideMenu] = useState(initSideMenu);
  const [sideMenuWide, setSideMenuWide] = useState(initSideMenuWide);
  const [searchTerm, setSearchTerm] = useState({query: ''});

  if (site) {
    return (
      <SearchTermContext.Provider value={{ searchTerm, setSearchTerm }}>
      <SectionContext.Provider value={{ section, setSection }}>
        <MenuContext.Provider value={{ menuObject, setMenuObject }}>
          <DrawerContext.Provider value={{ drawerActive, setDrawerActive }}>
            <SideMenuContext.Provider value={{ sideMenu, setSideMenu }}>
              <SideMenuWideContext.Provider
                value={{ sideMenuWide, setSideMenuWide }}
              >
                <BackToContext.Provider value={{ backTo, setBackTo }}>
                  <ActivePathContext.Provider
                    value={{ activePath, setActivePath }}
                  >
                    {children}
                  </ActivePathContext.Provider>
                </BackToContext.Provider>
              </SideMenuWideContext.Provider>
            </SideMenuContext.Provider>
          </DrawerContext.Provider>
        </MenuContext.Provider>
      </SectionContext.Provider>
      </SearchTermContext.Provider>
    );
  }
  return <React.Fragment>{children}</React.Fragment>;
};

export { ContextWrapper };
